import React from 'react';
import type { ContentfulComponentDefinition } from '../ContentfulComponent';
import type { AnimatedTextDefinition } from '../ContentfulComponent/AnimatedText';
import type { AnimatedText2Definition } from '../AnimatedText2';
import type { AnimatedTextGroupDefinition } from '../AnimatedTextGroup/AnimatedTextGroup';
import AnimatedTextGroup from '../AnimatedTextGroup/AnimatedTextGroup';
import AnimatedText from '../ContentfulComponent/AnimatedText';
import AnimatedText2 from '../AnimatedText2';

type AnimationComponent =
AnimatedTextDefinition
| AnimatedText2Definition
| AnimatedTextGroupDefinition;

export type AnimationsDefinition = ContentfulComponentDefinition & {
  animation: AnimationComponent[],
  internal: {
    type: 'ContentfulComponentAnimations',
  }
};

export type AnimationsProps = {
  content: AnimationsDefinition,
  className?: string
};

const returnAnimation = (item:AnimationComponent) => {
  switch (item.internal.type) {
    case 'ContentfulComponentAnimatedGroup':
      return <AnimatedTextGroup key={item.id} content={item as AnimatedTextGroupDefinition} />;
    case 'ContentfulComponentAnimatedText':
      return <AnimatedText {...item as AnimatedTextDefinition} containerClass="flex justify-start items-center flex-row m-[0.2em]" key={item.id} />;
    case 'ContentfulComponentAnimatedText2':
      return <AnimatedText2 key={item.id} content={{ ...item as AnimatedText2Definition }} />;
    default:
      return null;
  }
};

const Animations = ({
  content,
  className,
}: AnimationsProps) => (
  <div className={className}>
    {
      content.animation.map((item) => (
        returnAnimation(item)
      ))
    }
  </div>
);

export default Animations;
